import React from 'react';
import { useStringsContext } from '../../../../contexts/strings';
import Button from '@mui/material/Button';
import AddIcon from '@mui/icons-material/Add';
import Popover from '@mui/material/Popover';
import List from '@mui/material/List';
import ListItemButton from '@mui/material/ListItemButton';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import { PollType } from '../types';
import svStrings from '../../../../sv-strings';
import PersonIcon from '@mui/icons-material/Person';
import QuizIcon from '@mui/icons-material/Quiz';
import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted';
import SceneHeader from '../../../common/scene/scene-header';

type PollItem = {
  text: string;
  icon: JSX.Element;
};

const pollItems: Record<PollType, PollItem> = {
  playerofthematch: {
    text: svStrings.polls.pollTypePlayerOfTheMatch,
    icon: <PersonIcon />,
  },
  playerofthemonth: {
    text: svStrings.polls.pollTypePlayerOfTheMonth,
    icon: <PersonIcon />,
  },
  coachofthemonth: {
    text: svStrings.polls.pollTypeCoachOfTheMonth,
    icon: <PersonIcon />,
  },
  free: {
    text: svStrings.polls.pollTypeText,
    icon: <FormatListBulletedIcon />,
  },
  quiz: {
    text: svStrings.polls.pollTypeQuiz,
    icon: <QuizIcon />,
  },
};

interface Props {
  onAdd: (type: PollType) => void;
  isReadOnly: boolean;
}

const PollListHeader = ({ onAdd, isReadOnly }: Props) => {
  const { strings } = useStringsContext();

  const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(null);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleAdd = (type: PollType) => {
    onAdd(type);
    handleClose();
  };

  const open = Boolean(anchorEl);

  return (
    <>
      <SceneHeader title={strings.appBar.polls}>
        <Button
          variant="contained"
          onClick={handleClick}
          startIcon={<AddIcon />}
          disabled={isReadOnly}
        >
          {strings.polls.addPoll}
        </Button>
      </SceneHeader>
      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
      >
        <List>
          {Object.entries(pollItems).map(([type, { text, icon }]) => (
            <ListItem disablePadding key={type} onClick={() => handleAdd(type as PollType)}>
              <ListItemButton>
                <ListItemIcon>{icon}</ListItemIcon>
                <ListItemText primary={text} />
              </ListItemButton>
            </ListItem>
          ))}
        </List>
      </Popover>
    </>
  );
};

export default PollListHeader;
